// Section color theming — used throughout the app for visual differentiation
export const SECTIONS = {
  dashboard: {
    id: 'dashboard',
    label: 'Dashboard',
    color: '#3fa758',           // SP Green (Sanctuary Point brand)
    colorSoft: 'rgba(63,167,88,0.12)',
    colorBg: 'rgba(63,167,88,0.06)',
    ring: 'rgba(63,167,88,0.30)',
  },
  training: {
    id: 'training',
    label: 'Kestral K4 Resource',
    color: '#2563EB',           // Blue
    colorSoft: 'rgba(37,99,235,0.12)',
    colorBg: 'rgba(37,99,235,0.06)',
    ring: 'rgba(37,99,235,0.30)',
  },
  mbs: {
    id: 'mbs',
    label: 'MBS Monitor',
    color: '#16A34A',           // Green
    colorSoft: 'rgba(22,163,74,0.12)',
    colorBg: 'rgba(22,163,74,0.06)',
    ring: 'rgba(22,163,74,0.30)',
  },
  sops: {
    id: 'sops',
    label: 'SOPs',
    color: '#7C3AED',           // Purple
    colorSoft: 'rgba(124,58,237,0.12)',
    colorBg: 'rgba(124,58,237,0.06)',
    ring: 'rgba(124,58,237,0.30)',
  },
  contracts: {
    id: 'contracts',
    label: 'HR & Contracts',
    color: '#D97706',           // Amber
    colorSoft: 'rgba(217,119,6,0.12)',
    colorBg: 'rgba(217,119,6,0.06)',
    ring: 'rgba(217,119,6,0.30)',
  },
  compliance: {
    id: 'compliance',
    label: 'Compliance',
    color: '#DC2626',           // Red — regulatory / audit tone
    colorSoft: 'rgba(220,38,38,0.12)',
    colorBg: 'rgba(220,38,38,0.06)',
    ring: 'rgba(220,38,38,0.30)',
  },
  consent: {
    id: 'consent',
    label: 'Consent forms',
    color: '#7C2D12',           // Deep umber — formal / legal seal
    colorSoft: 'rgba(124,45,18,0.12)',
    colorBg: 'rgba(124,45,18,0.06)',
    ring: 'rgba(124,45,18,0.30)',
  },
  management: {
    id: 'management',
    label: 'Management',
    color: '#0E7490',
    colorSoft: 'rgba(14,116,144,0.12)',
    colorBg: 'rgba(14,116,144,0.06)',
    ring: 'rgba(14,116,144,0.30)',
  },
  people: {
    id: 'people',
    label: 'People',
    color: '#0891B2',
    colorSoft: 'rgba(8,145,178,0.12)',
    colorBg: 'rgba(8,145,178,0.06)',
    ring: 'rgba(8,145,178,0.30)',
  },
  referrers: {
    id: 'referrers',
    label: 'Referrers',
    color: '#0F766E',
    colorSoft: 'rgba(15,118,110,0.12)',
    colorBg: 'rgba(15,118,110,0.06)',
    ring: 'rgba(15,118,110,0.30)',
  },
  preparation: {
    id: 'preparation',
    label: 'Patient Prep',
    color: '#0891B2',           // Sky — patient-facing / reassuring
    colorSoft: 'rgba(8,145,178,0.12)',
    colorBg: 'rgba(8,145,178,0.06)',
    ring: 'rgba(8,145,178,0.30)',
  },
  anticoag: {
    id: 'anticoag',
    label: 'Anticoag screening',
    color: '#B91C1C',           // Bright red — safety-critical / clinical alert
    colorSoft: 'rgba(185,28,28,0.12)',
    colorBg: 'rgba(185,28,28,0.06)',
    ring: 'rgba(185,28,28,0.30)',
  },
  roster: {
    id: 'roster',
    label: 'Roster',
    color: '#7C3AED',           // Purple — team/workforce
    colorSoft: 'rgba(124,58,237,0.12)',
    colorBg: 'rgba(124,58,237,0.06)',
    ring: 'rgba(124,58,237,0.30)',
  },
};

export function sectionForPath(pathname) {
  if (pathname === '/' || pathname === '/dashboard-home') return SECTIONS.dashboard;
  if (pathname.startsWith('/people')) return SECTIONS.people;
  if (pathname.startsWith('/referrers')) return SECTIONS.referrers;
  if (pathname.startsWith('/dias-compliance')) return SECTIONS.compliance;
  if (pathname.startsWith('/management') || pathname === '/dashboard' || pathname.startsWith('/dashboard/')) return SECTIONS.management;
  if (pathname.startsWith('/mbs')) return SECTIONS.mbs;
  if (pathname.startsWith('/sops')) return SECTIONS.sops;
  if (pathname.startsWith('/contracts')) return SECTIONS.contracts;
  if (pathname.startsWith('/compliance')) return SECTIONS.compliance;
  if (pathname.startsWith('/consent')) return SECTIONS.consent;
  if (pathname.startsWith('/anticoag-screening')) return SECTIONS.anticoag;
  if (pathname.startsWith('/roster')) return SECTIONS.roster;
  if (pathname.startsWith('/preparation')) return SECTIONS.preparation;
  if (pathname.startsWith('/k4') || pathname.startsWith('/module') || pathname === '/search' || pathname === '/chat' || pathname.startsWith('/quick-ref')) return SECTIONS.training;
  return SECTIONS.dashboard;
}
